import { Divider, Grid, Popover } from "antd";
import { FC, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { SubMenuItem } from "src/constants/modules";
import { logout } from "src/store/slices/authentication/auth.slice";
import { RootState } from "src/store";
import useModuleSelect from "../../useModuleSelect";
import { BurgerIcon, ProfileIcon } from "src/assets/Icons";
import LanguageSwitch from "../LanguageSwitch/LanguageSwitch";
import ThemeSwitch from "../ThemeSwitch/ThemeSwitch";
import { MOBILE_BREAKPOINT_KEY } from "src/constants";
import { TbChevronDown } from "react-icons/tb";

const menuItemClass =
  "flex items-center gap-3 px-4 py-2.5 rounded-md text-sm font-medium cursor-pointer transition-colors w-full text-left";

const MenuContent: FC<{ items: SubMenuItem[]; onClose: () => void }> = ({ items, onClose }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const isIntegrated = useSelector((state: RootState) => state.auth.isIntegrated);

  const userItems = items.filter((i) => i.underMenu === "User");
  const actionItems = items.filter((i) => i.underMenu === "Action" && !(i.hideWhenIntegrated && isIntegrated));

  /*ew & Change Later, for accessibility */
  const handleClick = (item: SubMenuItem) => {
    if (item.route === "signout") {
      dispatch(logout());
    } else {
      navigate(`/${item.route}`);
    }
    onClose();
  };

  return (
    <div className="flex min-w-44 flex-col gap-1 p-1">
      {userItems.map((item) => (
        <button key={item.key} className={`${menuItemClass} text-font-subtle hover:bg-background-hover`} onClick={() => handleClick(item)}>
          <span className="flex h-4 w-4 items-center justify-center">{item.icon}</span>
          {t(item.label)}
        </button>
      ))}

      {userItems.length > 0 && <Divider className="my-1!" />}

      <LanguageSwitch className={`${menuItemClass} text-font-subtle hover:bg-background-hover`} />
      <ThemeSwitch className={`${menuItemClass} text-font-subtle hover:bg-background-hover`} />

      {actionItems.length > 0 && <Divider className="my-1!" />}

      {actionItems.map((item) => (
        <button key={item.key} className={`${menuItemClass} text-font-danger hover:bg-background-danger`} onClick={() => handleClick(item)}>
          <span className="flex h-4 w-4 items-center justify-center">{item.icon}</span>
          {t(item.label)}
        </button>
      ))}
    </div>
  );
};

export default function BurgerMenu() {
  const [open, setOpen] = useState(false);
  const { items } = useModuleSelect();
  const isLargeScreen = Grid.useBreakpoint()[MOBILE_BREAKPOINT_KEY];

  return (
    <Popover
      arrow={false}
      trigger={["click"]}
      placement="bottomRight"
      open={open}
      onOpenChange={setOpen}
      content={<MenuContent items={items} onClose={() => setOpen(false)} />}
    >
      <button className="border-border-default text-icon-default flex cursor-pointer items-center justify-center rounded-full border p-2 bg-background-minimal">
        {isLargeScreen ? (
          <span className="flex items-center gap-1 px-1">
            <span className="rounded-full bg-background-subtle">
              <ProfileIcon />
            </span>
            <TbChevronDown />
          </span>
        ) : (
          <span className="p-1 text-icon-default">
            <BurgerIcon strokeWidth={1} className="h-4 w-4 text-icon-default" />
          </span>
        )}
      </button>
    </Popover>
  );
}
